import ApiClient from '@/libs/http-client'

const NotificationsService = {
    endpoints(route, param) {
        const url = {
            getNotifications: '/api/notifications',
            deleteNotification: `/api/notifications/${param}`,
            deleteAllNotifications: `/api/notifications`,
            checkAll: '/api/notifications/check',
            checkNotification: `/api/notifications/${param}/check`,

        }
        return url[route]
    },
    get(url, param = {}) {
        return ApiClient.get(this.endpoints(url, param));
    },
    put(url, params = {}, data, config = {}) {
        return ApiClient.put(this.endpoints(url, params), data, config);
    },
    post(url, params = {}, data, config = {}) {
        return ApiClient.post(this.endpoints(url, params), data, config);
    },
    patch(url, params = {}, data, config = {}) {
        return ApiClient.patch(this.endpoints(url, params), data, config);
    },
    delete(url, params = {}, config = {}) {
        return ApiClient.delete(this.endpoints(url, params), config);
    },
    postFile(url, params = {}, data, config = {}) {
        config = {
            headers: {
                "Accept": "application/json",
                "Content-Type": "multipart/form-data",
            },
            ...config
        }
        return ApiClient.post(this.endpoints(url, params), data, config);
    },






    checkNotification(id, config ) {
        return ApiClient.post(`/api/notifications/${id}/check`, config)
    },

    checkAllNotifications(config ) {
        return ApiClient.post(`/api/notifications/check`, config)
    },


}

export default NotificationsService
